<template>
  <div>
    <div class="row">
      <div class="col col-sm-4 offset-4 mt-2 text-center">
        <h5 class="font-weight-bold">
          Available Schedules
        </h5>
      </div>
      <div class="col col-sm-4 text-center mb-2">
        <button
          type="button"
          data-toggle="modal"
          data-target="#addSchedule"
          title="Add Training Provider"
          class="btn btn-sm btn-outline-primary font-weight-bolder mr-2"
        >
          <span><i class="fas fa-clock" /></span>
          Add Schedule
        </button>
      </div>
    </div>
    <table class="table table-bordered">
      <thead class="table-header">
        <tr>
          <th>MONDAY</th>
          <th>TUESDAY</th>
          <th>WEDNESDAY</th>
          <th>THURSDAY</th>
          <th>FRIDAY</th>
          <th>SATURDAY</th>
          <th>SUNDAY</th>
        </tr>
      </thead>

      <tr>
        <td
          v-for="dayOfWeek in daysOfWeek"
          :key="dayOfWeek.day"
        >
          <div
            class="row"
            v-for="schedule in trainingCenterSchedules.filter(sched => sched.weekday_id === dayOfWeek.day)"
            :key="schedule.id"
          >
            <div class="col col-sm-12">
              <a
                href=""
                role="button"
                data-toggle="modal"
                data-target="#viewSchedule"
                class="btn btn-sm btn-block btn-light mb-1"
                :class="{'inactive': !schedule.status}"
                @click="setTrainingCenterSchedule(schedule.id)"
              >
                <small>
                  {{ schedule.time_from | parseTime }} -
                  {{ schedule.time_to | parseTime }}
                </small>
              </a>
            </div>
          </div>
        </td>
      </tr>
    </table>

    <app-add-schedule />
    <view-add-schedule />
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { formMixins } from "../../../../mixins/formMixins";
    import AddTrainingCenterSchedule from "./AddTrainingCenterSchedule";
    import ViewTrainingCenterSchedule from "./ViewTrainingCenterSchedule";

    export default {
        mixins: [  formMixins ],
        name: "TrainingCenterSchedule",
        methods: {
            ...mapActions([ 'getTrainingCenterSchedules', 'setTrainingCenterSchedule' ]),
        },
        components: {
            'app-add-schedule': AddTrainingCenterSchedule,
            'view-add-schedule': ViewTrainingCenterSchedule
        },
        computed: {
            ...mapGetters([ 'trainingCenterSchedules', 'daysOfWeek' ])
        },
        created() {
            this.getTrainingCenterSchedules(this.$route.params.id);
        }
    }
</script>

<style scoped>

</style>
